import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { PERMISSION_DELETE } from "graphql/mutation/permission-gql";
import PermissionConst from "../permission-const";
import {
    successNotification,
    errorNotification,
} from "components/request-result";

interface IPermissionDeleteResponse {
    permissionDelete: {
        label: string;
        message: string;
    };
}

const useMutationPermissionDelete = (id: string | undefined) => {
    const navigate = useNavigate();

    const [_setMutationPermissionDelete, { loading }] = useMutation<IPermissionDeleteResponse>(PERMISSION_DELETE, {
        update(cache, { data }) {
            if (data) {
                const {
                    permissionDelete: { label, message },
                } = data;

                navigate(PermissionConst.basePath);

                cache.evict({
                    id: cache.identify({ id, __typename: "Permission" }),
                });
                cache.gc();

                successNotification({
                    title: label.toUpperCase(),
                    description: message,
                });
            }
        },
        onError(error) {
            errorNotification(error);
        },
    });

    const handleDelete = async (options: { variables: Record<string, any> }) => {
        await _setMutationPermissionDelete(options);
    };

    return {
        _setMutationPermissionDelete: handleDelete,
        loadingMutationPermissionDelete: loading,
    };
};

export default useMutationPermissionDelete;